import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import {
  ConfiguracionFormulario,
  TipoCampoFormulario,
  PosicionLabelFormulario,
  DisplayFormulario,
} from 'src/app/compartido/formulario/utilidades/formulario.models';
import {
  OPCIONES_CIUDADES_FORMULARIO,
  OPCIONES_DEPARTAMENTOS_FORMULARIO,
} from 'src/app/compartido/formulario/utilidades/formulario.static';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';
import {
  OPCIONES_PRIORIDAD_ORDEN,
  OPCIONES_TIPO_ORDEN,
} from 'src/app/ordenes/utilidades/ordenes.static';

/* Configuración de la ficha de crear domicilio */
export const CONFIGURACION_FICHA_CREAR_ORDEN: ConfiguracionFicha = {
  header: { titulo: 'Crear Orden', icono: Icono.ORDENES },
  contenido: { padding: true },
  maxWidth: 700,
};

/* Configuración del formulario de crear orden */
export const CONFIGURACION_FORMULARIO_CREAR_ORDEN: ConfiguracionFormulario = {
  campos: [
    {
      nombre: 'Organización',
      slug: 'organizacion',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [], // Se obtiene del servidor
      requerido: true,
    },
    {
      nombre: 'Tipo',
      slug: 'tipo',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: OPCIONES_TIPO_ORDEN,
      requerido: true,
    },
    {
      nombre: 'Prioridad',
      slug: 'prioridad',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: OPCIONES_PRIORIDAD_ORDEN.filter(
        (opcion) => opcion.valor !== 'express',
      ),
      valor: 'next_day',
      requerido: true,
    },
    {
      nombre: 'Servicio',
      slug: 'servicio',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [
        { valor: 'Pendiente', nombre: 'Pendiente' },
        { valor: 'PQR', nombre: 'PQR' },
        { valor: 'PAC', nombre: 'Paciente PAC' },
        { valor: '', nombre: 'Otro' },
      ],
      requerido: true,
    },
    {
      nombre: 'Punto de Origen',
      slug: 'origen',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [],
      oculto: true,
    },
    {
      nombre: 'Recaudo',
      slug: 'recaudo',
      tipo: TipoCampoFormulario.NUMERO,
      minimo: 0,
    },
    {
      nombre: 'Identificación',
      slug: 'identificacion',
      tipo: TipoCampoFormulario.AUTOCOMPLETE,
      opciones: [], // Se obtiene del servidor
      requerido: true,
    },
    {
      nombre: 'Nombres y Apellidos',
      slug: 'nombre',
      tipo: TipoCampoFormulario.TEXTO,
      requerido: true,
    },
    {
      nombre: 'Correo Electrónico',
      slug: 'correo',
      tipo: TipoCampoFormulario.TEXTO,
      correo: true,
    },
    {
      nombre: 'Teléfono Celular',
      slug: 'celular',
      tipo: TipoCampoFormulario.NUMERO,
      requerido: true,
      longitudMinima: 10,
      longitudMaxima: 10,
    },
    {
      nombre: 'Teléfono Fijo',
      slug: 'telefono',
      tipo: TipoCampoFormulario.NUMERO,
      telefono: true,
      longitudMinima: 7,
      longitudMaxima: 7,
    },
    {
      nombre: 'Dirección',
      slug: 'direccion',
      tipo: TipoCampoFormulario.AUTOCOMPLETE,
      opciones: [], // Se obtiene del servidor
      requerido: true,
    },
    {
      nombre: 'Formateada',
      slug: 'direccion_formateada',
      tipo: TipoCampoFormulario.TEXTO,
      oculto: true,
    },
    {
      nombre: 'Detalles',
      slug: 'detalles',
      tipo: TipoCampoFormulario.TEXTO,
      placeholder: 'Apartamento, casa, torre, etc.',
      requerido: true,
    },
    {
      nombre: 'Barrio',
      slug: 'barrio',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Localidad',
      slug: 'localidad',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Ciudad',
      slug: 'ciudad',
      tipo: TipoCampoFormulario.AUTOCOMPLETE,
      opciones: OPCIONES_CIUDADES_FORMULARIO,
      requerido: true,
      soloOpcion: true,
      filtrarOpciones: true,
    },
    {
      nombre: 'Departamento',
      slug: 'departamento',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: OPCIONES_DEPARTAMENTOS_FORMULARIO,
      requerido: true,
    },
    {
      nombre: 'Latitud',
      slug: 'latitud',
      tipo: TipoCampoFormulario.NUMERO,
      decimal: true,
      oculto: true,
    },
    {
      nombre: 'Longitud',
      slug: 'longitud',
      tipo: TipoCampoFormulario.NUMERO,
      decimal: true,
      oculto: true,
    },
    {
      nombre: 'N° Referencia',
      slug: 'referencia',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Notas',
      slug: 'notas',
      tipo: TipoCampoFormulario.TEXTO,
    },
  ],
  estilo: {
    display: DisplayFormulario.GRID,
    posicionLabel: PosicionLabelFormulario.TOP,
    widthCampo: 200,
    widthLabel: 200,
    marcarRequeridos: true,
  },
};

/* Configuración del formulario de item de orden */
export const CONFIGURACION_FORMULARIO_ITEM_ORDEN: ConfiguracionFormulario = {
  campos: [
    {
      nombre: 'Producto',
      slug: 'producto',
      tipo: TipoCampoFormulario.AUTOCOMPLETE,
      opciones: [], // Se obtiene del servidor
      requerido: true,
    },
    {
      nombre: 'Cantidad',
      slug: 'cantidad',
      tipo: TipoCampoFormulario.NUMERO,
      requerido: true,
      minimo: 1,
    },
  ],
  estilo: {
    display: DisplayFormulario.GRID,
    posicionLabel: PosicionLabelFormulario.TOP,
    widthCampo: 200,
    widthLabel: 200,
    esconderErrores: true,
  },
};

/* Configuración del formulario de fórmula de orden */
export const CONFIGURACION_FORMULARIO_FORMULA_ORDEN: ConfiguracionFormulario = {
  campos: [
    {
      nombre: 'No. de Fórmula',
      slug: 'referencia',
      tipo: TipoCampoFormulario.TEXTO,
    },
    {
      nombre: 'Adjuntar Fórmula',
      slug: 'archivo',
      tipo: TipoCampoFormulario.ARCHIVO,
      aceptados: ['.pdf', '.png', '.jpg'],
      requerido: true,
    },
  ],
  estilo: {
    display: DisplayFormulario.GRID,
    posicionLabel: PosicionLabelFormulario.TOP,
    widthCampo: 200,
    widthLabel: 200,
  },
};
